import React from 'react'
import { select_arrow } from '../../../assets/images'

const SelectInput = ({ name = '', label = '', value = '', placeholder = '', icon ,  inputClasses = '', selectList = [], handler, labelClasses = '', classes = '', iconPosition = '96%', disable = false, inputBackColor = '#f5f7f9' }) => {
  labelClasses = labelClasses || 'text-gray-700 font-semibold'

  return (
    <div className={classes + ' relative'}>
      {label && <span className={'block mb-2 ' + labelClasses}>{label}</span>}
      <select name={name} value={value} placeholder={placeholder} onChange={handler} disabled={disable} className={`border border-gray-200 h-12 py-1.5 px-4 pr-7 rounded-md w-full text-gray-300 font-semibold  ${inputClasses}`} style={{background: ` ${inputBackColor} url(${icon || select_arrow}) ${iconPosition} center no-repeat`}}>
        {selectList.map((item) => {
          return (
            <option key={item} value={item}>
              {item}
            </option>
          )
        })}
      </select>
    </div>
  )
}

export default SelectInput
